import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { batchActions } from 'redux-batched-actions';

import Loading from '../CircularLoading';
import { resetLinkRequest, unsetError } from '../../actions/integrations';
import { fetchLinkRequest } from '../../actions/integrations';

export class LinkRequestChannelContentComponent extends Component {
    static propTypes = {
        channelState: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
        linkError: PropTypes.string,
        type: PropTypes.string,
    };

    onLink = () => {
        const { dispatch, type } = this.props;
        dispatch(resetLinkRequest(type));
    };

    onTryAgain = () => {
        const { dispatch, type } = this.props;
        dispatch(batchActions([unsetError(type), resetLinkRequest(type)]));
        dispatch(fetchLinkRequest(type));
    };

    render() {
        const { channelState, linkError } = this.props;
        const { linkRequest, hasError } = channelState;

        if (hasError) {
            return (
                <a className="error-link" onClick={this.onTryAgain}>
                    {linkError}
                </a>
            );
        }

        if (linkRequest) {
            return (
                <a alt="Connect" target="_blank" rel="noopener noreferrer" onClick={this.onLink} href={linkRequest.url}>
                    Connect
                </a>
            );
        }

        const loadingStyle = {
            height: '40px',
            width: '40px',
            margin: 'auto',
        };

        return <Loading dark={true} style={loadingStyle} />;
    }
}

export default connect(
    ({ ui: { text } }) => {
        return {
            linkError: text.linkError,
        };
    },
    null,
    null,
    { forwardRef: true },
)(LinkRequestChannelContentComponent);
